import { Controller } from "@hotwired/stimulus";
import { get, FetchRequest } from "@rails/request.js";

export default class extends Controller {
  static values = {
    interval: Number,
    pingUrl: String,
    updatedAt: String
  }

  connect() {
    this.counter = this.intervalValue;
    setTimeout(this.countdown.bind(this), 1000);
  }

  countdown() {
    this.counter--;

    if (this.counter > 0) {
      this.element.textContent = `Atualizando automaticamente em ${this.counter}s`;
      setTimeout(this.countdown.bind(this), 1000);
    } else {
      get(this.pingUrlValue, { responseKind: "text" }).then((response) => {
        if (response.ok) {
          response.text.then((text) => {
            if (text == this.updatedAtValue) {
              this.counter = this.intervalValue; // reset counter
              setTimeout(this.countdown.bind(this), 1000);
            } else {
              Turbo.visit(window.location);
            }
          });
        }
      });
    }
  }
}
